var map = {
  "./cs.json": [
    "oM",
    [
      "a1q"
    ]
  ],
  "./en.json": [
    "WJG",
    [
      "swr"
    ]
  ],
  "./pl.json": [
    "cxs",
    [
      "if"
    ]
  ],
  "./ru.json": [
    "r8",
    [
      "tx"
    ]
  ],
  "./tr.json": [
    "NN9",
    [
      "75g"
    ]
  ],
  "./ja.json": [
    "Qev",
    [
      "ep"
    ]
  ],
  "./zh.json": [
    "l8F",
    [
      "r6"
    ]
  ],
  "./pt-br.json": [
    "tJD",
    [
      "rnv"
    ]
  ],
  "./de.json": [
    "obd",
    [
      26
    ]
  ],
  "./es.json": [
    "ZN",
    [
      "vy"
    ]
  ],
  "./fr.json": [
    "Ng",
    [
      "f6"
    ]
  ],
  "./it.json": [
    "zC",
    [
      "t3f"
    ]
  ],
  "./ko.json": [
    "eb",
    [
      "gg"
    ]
  ],
  "./pt.json": [
    "ya",
    [
      "o6r"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "iS";
module.exports = __rspack_async_context;
